import React, { useEffect, useState } from 'react';
// Constants
import {
  CompanyName,
  KeywordsPages,
  LocationCountry,
  ServiceArea,
} from '../../utils/Constants';
// Data
import {
  faqPageStructuredData,
  faqPageAdditionalMeta,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import GeneralHeader from '../../components/header/GeneralHeader';
import FaqMainContainer from '../../components/faq/FaqMainContainer';
import FooterComponent from '../../components/footer/FooterComponent';

function FaqPage() {
  const [hideNavbar, setHideNavbar] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById('scroll-section-faq');
      if (!section) return;

      const sectionBottom = section.getBoundingClientRect().bottom;
      setHideNavbar(sectionBottom <= 130); // Hide navbar 50px before section disappears
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='FAQ'
        desc={`${CompanyName} - Elite Dominatrix & BDSM Specialist based in ${LocationCountry}, serving the ${ServiceArea}.`}
        keywords={KeywordsPages}
        additionalMeta={faqPageAdditionalMeta}
        structuredData={faqPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen font-main bg-colour1 dark:bg-colour2 text-colour2 dark:text-colour1 overflow-hidden'>
        {/* Nav + header section */}
        <div
          id='scroll-section-faq'
          className='grid bg-colour4 dark:bg-colour4 full_shadow_black_invert min-h-[45vh] max-h-[45vh]'
        >
          {/* Navigation */}
          <Navbar isHidden={hideNavbar} />
          {/* Header */}
          <GeneralHeader
            page={`FAQ`}
            title={`Ask Miss About What Turns You On!`}
          />
        </div>

        {/* Main page content */}
        <FaqMainContainer />

        <FooterComponent />
      </div>
    </>
  );
}

export default FaqPage;
